<div class="login-container">
  <!-- Success Notification (Top Right) -->
  <div *ngIf="successMessage" class="success-notification">
    <svg class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="success-notification-message">{{ successMessage }}</span>
  </div>

  <!-- Error Notification (Top Right) -->
  <div *ngIf="error" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ error }}</span>
  </div>

  <div class="login-wrapper">
    <!-- Logo and Company Name -->
    <div class="logo-section">
      <div class="logo">
        <div class="logo-shape">
          <img src="assets/public/Aeroplast Logo.svg" alt="Aero Plast Logo" class="logo-image">
        </div>
      </div>
      <!-- <div class="company-info">
        <h1 class="company-name">Aero Plast</h1>
        <p class="company-tagline">Since 1978</p>
      </div> -->
    </div>

    <!-- Login Form -->
    <div class="login-form-container">
      <h2 class="login-title">Login</h2>
      <form (ngSubmit)="onSubmit()" class="login-form">
        <div class="form-group">
          <label for="userType">User Type<span class="required-asterisk">*</span></label>
          <select 
            id="userType" 
            class="form-control" 
            [class.error]="userTypeError"
            [(ngModel)]="userType" 
            name="userType" 
            (change)="clearError(); userTypeError = ''"
            required>
            <option value="">Select User Type</option>
            <option value="Admin">Admin</option>
            <option value="ProcurementManager">Procurement Manager</option>
            <option value="Supplier">Supplier</option>
          </select>
          <small class="text-danger" *ngIf="userTypeError">{{ userTypeError }}</small>
        </div>

        <div class="form-group">
          <label for="email">Email ID<span class="required-asterisk">*</span></label>
          <input 
            type="email" 
            id="email"
            class="form-control" 
            [class.error]="emailError"
            [(ngModel)]="email" 
            name="email" 
            placeholder="Enter Email ID"
            (input)="clearError(); emailError = ''"
            required>
          <small class="text-danger" *ngIf="emailError">{{ emailError }}</small>
        </div>

        <div class="form-group">
          <label for="password">Password<span class="required-asterisk">*</span></label>
          <div class="password-input-wrapper">
            <input 
              [type]="showPassword ? 'text' : 'password'" 
              id="password"
              class="form-control" 
              [class.error]="passwordError"
              [(ngModel)]="password" 
              name="password" 
              placeholder="Enter Password"
              (input)="clearError(); passwordError = ''"
              required>
            <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
              <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="10" cy="10" r="3" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 3L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <small class="text-danger" *ngIf="passwordError">{{ passwordError }}</small>
        </div>

        <button type="submit" class="btn-login" [disabled]="loading">
          {{ loading ? 'Logging in...' : 'Login' }}
        </button>
      </form>
    </div>
  </div>
</div>

